import { useSelector } from 'react-redux'
import { selectIsBetLoopAccessRestricted } from '@core/Store/Config/selectors'
import { useGetCountryEntitlements } from '@core/Utils/hooks/useGetCountryEntitlements'

export const useIsBetLoopEntitled = () => {
  const isCountryEntitled = useGetCountryEntitlements()
  const isBetLoopAccessRestricted = useSelector(selectIsBetLoopAccessRestricted)

  const isEntitled = !isBetLoopAccessRestricted && isCountryEntitled

  return isEntitled
}
